import {get, clone} from 'lodash';

import {getTokenLabel} from '@packages/systems/style-legacy/selectors';
import {createVariantKey} from '@packages/systems/style-legacy/variants';

import type {
  StyleStateType,
  StyleProperty,
  StyleStore$ValueType,
  CssSelectorValue,
} from '@packages/systems/style-legacy/values';
import {Component} from '@packages/systems/wfdl';

const getIn = (o: StyleStateType, path: Array<string>) =>
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'StyleStateType'.
  // eslint-disable-next-line @typescript-eslint/no-shadow
  path.reduce((o, k) => o && o[k], o);

export const setIn = (
  state: StyleStateType,
  path: Array<string>,
  v: any
): StyleStateType => {
  if (get(state, path) === v) {
    return state;
  }
  return path.reduceRight(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (v, k, i, ks) => {
      const val = getIn(state, ks.slice(0, i));
      if (Array.isArray(val)) {
        const c = val.slice(0);
        // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
        c[k] = v;
        return c;
      }
      return Object.assign({}, val, {[k]: v} as any);
    },
    v
  );
};

export function sourceToCssTokensSpec(
  source: any,
  currentComponent: Component.ComponentType
): CssSelectorValue {
  const chunks: CssSelectorValue['chunks'] = (() => {
    const sourceKey = createVariantKey(source);

    // @ts-expect-error - TS7006 - Parameter 'chunk' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
    return source.chunks.map((chunk, i) => {
      const chunkKey = sourceKey + ':' + i;

      return {
        // @ts-expect-error - TS7006 - Parameter 'token' implicitly has an 'any' type. | TS7006 - Parameter 'j' implicitly has an 'any' type.
        tokens: chunk.tokens.map((token, j) => {
          const tokenKey = chunkKey + ':' + j;

          return {
            label: getTokenLabel(token, currentComponent),
            pseudo: chunk.pseudoState,
            state: chunk.customNodeState,
            variantState: token.variantState,
            namespace: token.namespace,
            origin: token.origin,
            isTag: Boolean(token.tagName),
            guid: tokenKey,
          };
        }),
      };
    });
  })();

  return {
    mediaQueryKey: source.mediaQuery,
    chunks,
    // @ts-expect-error - Unchecked bounds access
    lastChunk: chunks[chunks.length - 1],
    pathChunks: chunks.slice(0, -1),
  };
}

// Helpers
export function normalizeValue<V extends StyleStore$ValueType>(
  value: Record<any, any>
): StyleProperty<V> {
  value = value || {};

  return {
    local: normalizeSubValue(value.local),
    upstream: normalizeSubValue(value.upstream),
    downstream: normalizeSubValue(value.downstream),
    browser: normalizeSubValue(value.browser),
    default: normalizeSubValue(value.default),
    placeholder: normalizeSubValue(value.placeholder),
    id: normalizeSubValue(value.id),
    valueFrom: value.valueFrom || null,
    valueOverride: value.valueOverride || null,
  };
}

export function normalizeSubValue(subvalue?: {
  readonly raw: any;
  readonly value: any;
  readonly unit: any;
  readonly source?: any;
}) {
  if (subvalue) {
    subvalue = clone(subvalue);
    // @ts-expect-error - TS2540 - Cannot assign to 'value' because it is a read-only property.
    typeof subvalue.value === 'undefined' && (subvalue.value = null);
    // @ts-expect-error - TS2540 - Cannot assign to 'unit' because it is a read-only property.
    typeof subvalue.unit === 'undefined' && (subvalue.unit = null);
    // @ts-expect-error - TS2540 - Cannot assign to 'raw' because it is a read-only property.
    typeof subvalue.raw === 'undefined' && (subvalue.raw = null);
    return subvalue;
  } else {
    return {value: null, unit: null, raw: null};
  }
}
